import { render, staticRenderFns } from "./EditarEvento.vue?vue&type=template&id=63fd26a2"
import script from "./EditarEvento.vue?vue&type=script&lang=ts"
export * from "./EditarEvento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports